<div class="month-title">
  <p class="font-sans text-h600 text-eggplant-100/[0.25] pb-[30px]">{{monthWithBenefits.dateName}}</p>
</div>
<div class="mb-48 bg-white rounded-2xl">
  <ng-container *ngFor="let benefit of monthWithBenefits.benefits; let i = index">
      <div class="w-full relative flex">
          <div class="inline-block w-full px-16 md:px-[40px]">
            <div class="py-16 md:py-[28px]" [ngClass]="{ 'border-b border-b-eggplant-100/[0.1]': i + 1 < monthWithBenefits.benefits.length }">
              <div class="flex">
                <div class="w-full">
                  <p *ngIf="!benefit.paymentStatus"
                  class="font-sans text-s md:text-m text-center w-fit px-8 rounded-xl pt-[3px] pb-2 bg-cream-100 text-eggplant-100">Estimado</p>
                  <div *ngIf="benefit.paymentStatus" class="flex gap-12 items-center">
                    <p
                    class="font-sans text-s md:text-m text-center w-fit px-8 rounded-xl pt-[3px] pb-2"
                    [ngClass]="{
                      'bg-[#e0e3ff] text-verified': benefit.paymentStatus === 'Programado',
                      'bg-gray-10 text-eggplant-100': benefit.paymentStatus === 'Aplazado',
                      'bg-[#EBFCF2] text-success': benefit.paymentStatus === 'Pagado',
                      'bg-[#FDEDED] text-alert': benefit.paymentStatus === 'Cancelado',
                      'bg-cream-100 text-eggplant-100': (benefit.paymentStatus !== 'Programado' && benefit.paymentStatus !== 'Aplazado' && benefit.paymentStatus !== 'Cancelado' && benefit.paymentStatus !== 'Pagado')
                    }"> {{ benefit.paymentStatus }} </p>
                    <p class="text-l font-sans text-eggplant-80"
                    [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">{{ benefit.date[2] }}/{{ benefit.date[1] }}/{{ benefit.date[0] }}</p>
                  </div>

                  <p *ngIf="!benefit.paymentTitle" class="font-sans text-l md:text-2xl text-eggplant-80 pt-6"
                  [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">{{'PAYMENT_CALENDAR.BENEFITS_COMMON_TYPE' | translate}}</p>
                  <p *ngIf="benefit.paymentTitle" class="font-sans text-l md:text-2xl text-eggplant-80 pt-6"
                  [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">{{ benefit.paymentTitle }}</p>
                  <p class="font-sans text-s md:text-l text-eggplant-100/[0.55]"
                  [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">{{benefit.projectName}}</p>
                </div>
                <div class="min-w-[80px] md:min-w-[146px] pl-6 py-6 md:py-0 flex items-center justify-center">
                  <p *ngIf="benefit.amount > 0" class="text-right font-sans text-l md:text-xl text-eggplant-80"
                    [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">{{benefit.amount | currency: 'EUR': 'symbol': '1.2-2'}}</p>
                  <p *ngIf="benefit.amount === 0" class="text-right font-sans text-s md:text-l text-eggplant-100/[0.55]"
                  [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">Por determinar</p>
                </div>
              </div>
              <div *ngIf="benefit.paymentDescription"><p class="font-sans text-m md:text-l text-eggplant-80 pt-16"
                [ngClass]="{'line-through decoration-eggplant-80 decoration-2': (benefit.paymentStatus === 'Cancelado')}">{{ benefit.paymentDescription }}</p></div>
            </div>
          </div>
      </div>
  </ng-container>
</div>
